import { useCallback, useState } from "react"
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import { useUnmutePlayerTOHMutation } from "../../core/api/toh-clans-api"

const TohUnmuteControl = ({ disabled, userId }) => {
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [unmute, { isLoading }] = useUnmutePlayerTOHMutation()

    const handleOpenConfirm = useCallback(() => {
        setConfirmOpen(true)
    }, [])

    const handleCloseConfirm = useCallback(() => {
        setConfirmOpen(false)
    }, [])

    const handleConfirm = useCallback(async () => {
        await unmute({ userId })
        setConfirmOpen(false)
    }, [unmute, userId])

    return (
        <>
            <Button
                fullWidth
                size="small"
                loading={isLoading}
                disabled={disabled}
                onClick={handleOpenConfirm}
            >
                Unmute
            </Button>
            <Dialog open={confirmOpen} onClose={handleCloseConfirm}>
                <DialogTitle>Unmute player '{userId}'?</DialogTitle>
                <DialogActions>
                    <Button onClick={handleCloseConfirm}>Cancel</Button>
                    <Button variant="contained" loading={isLoading} onClick={handleConfirm}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TohUnmuteControl
